import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.finalClasses)
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
    (_ctx.isCloseButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "bg-transparent text-xl font-semibold leading-none outline-none focus:outline-none cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeBadge()))
        }, _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}